export const paymentsSection = '/payments';

export const payLinksPath = '/pay-links';
export const payLinksCreatePath = payLinksPath + '/create';
export const payLinksDetailPath = (id: string) => `${payLinksPath}/${id}`;
export const payLinksDetailRoute = payLinksPath + '/:invoiceId';

export const quickPayPath = '/quick-pay';
export const quickPayCreatePath = quickPayPath + '/create';
export const quickPayDetailPath = (id: string) => `${quickPayPath}/${id}`;
export const quickPayDetailRoute = quickPayPath + '/:quickPayId';

export const recurringPaymentSection = '/recurring-payment';
export const recurringPaymentCreatePath = recurringPaymentSection + '/detail/create';
export const recurringPaymentDetailPath = (id: string) => `${recurringPaymentSection}/detail/${id}`;
export const recurringPaymentDetailRoute = recurringPaymentSection + '/detail/:id';

export const checkoutsPath = '/checkouts';
export const checkoutsDetailPath = (id: string) => `${checkoutsPath}/${id}`;
export const checkoutsDetailRoute = checkoutsPath + '/:id';

export const mobileAppPath = '/mobile-app';

export const payoutsPath = '/payouts';
export const payoutDetailPath = (id: string) => `${payoutsPath}/${id}`;
export const payoutDetailRoute = payoutsPath + '/:id';

export const paymentDetailPath = (id: string) => `${paymentsSection}/${id}`;
export const paymentDetailRoute = paymentsSection + '/:paymentId';
